var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHerocelebrate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4419_239091)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.6016,
    y: 36.9624,
    width: 50,
    height: 50,
    rx: 10,
    fill: "#36B696"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.1016,
    y: 38.4624,
    width: 47,
    height: 47,
    rx: 8.5,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.556 75.9541C47.9818 76.1455 47.4794 76.0258 47.0488 75.5952C46.6181 75.1646 46.4985 74.6621 46.6899 74.088L51.3193 61.1328C51.6782 60.128 52.372 59.5117 53.4007 59.284C54.4295 59.0562 55.3147 59.3136 56.0563 60.0562L62.5877 66.5876C63.3294 67.3293 63.5868 68.2145 63.36 69.2432C63.1332 70.272 62.5169 70.9658 61.5111 71.3247L48.556 75.9541ZM62.9466 62.6401C62.7313 62.4248 62.6236 62.1736 62.6236 61.8865C62.6236 61.5994 62.7313 61.3482 62.9466 61.1328L70.2316 53.8478C70.9972 53.0822 71.9183 52.6995 72.9949 52.6995C74.0715 52.6995 74.9926 53.0822 75.7582 53.8478L75.9017 53.9914C76.0931 54.1828 76.1888 54.422 76.1888 54.7091C76.1888 54.9962 76.0811 55.2474 75.8658 55.4627C75.6505 55.6781 75.3993 55.7857 75.1122 55.7857C74.8251 55.7857 74.5739 55.6781 74.3586 55.4627L74.2509 55.3551C73.916 55.0201 73.4973 54.8527 72.9949 54.8527C72.4925 54.8527 72.0738 55.0201 71.7388 55.3551L64.418 62.676C64.2266 62.8674 63.9873 62.9631 63.7002 62.9631C63.4131 62.9631 63.1619 62.8554 62.9466 62.6401ZM57.2047 56.8982C56.9894 56.6829 56.8817 56.4317 56.8817 56.1446C56.8817 55.8575 56.9894 55.6063 57.2047 55.391L57.3124 55.2833C57.6473 54.9484 57.8148 54.5416 57.8148 54.0631C57.8148 53.5847 57.6473 53.1779 57.3124 52.843L57.0971 52.6277C56.9057 52.4363 56.81 52.197 56.81 51.9099C56.81 51.6229 56.9176 51.3716 57.1329 51.1563C57.3483 50.941 57.5995 50.8333 57.8866 50.8333C58.1737 50.8333 58.4249 50.941 58.6402 51.1563L58.8196 51.3358C59.5852 52.1013 59.968 53.0105 59.968 54.0631C59.968 55.1158 59.5852 56.025 58.8196 56.7905L58.6761 56.9341C58.4847 57.1255 58.2454 57.2212 57.9583 57.2212C57.6712 57.2212 57.42 57.1135 57.2047 56.8982ZM60.0757 59.7691C59.8603 59.5538 59.7527 59.3026 59.7527 59.0155C59.7527 58.7284 59.8603 58.4772 60.0757 58.2619L64.4897 53.8478C64.8247 53.5129 64.9921 53.0942 64.9921 52.5918C64.9921 52.0894 64.8247 51.6707 64.4897 51.3358L62.9107 49.7567C62.7193 49.5653 62.6236 49.3261 62.6236 49.039C62.6236 48.7519 62.7313 48.5007 62.9466 48.2854C63.1619 48.0701 63.4131 47.9624 63.7002 47.9624C63.9873 47.9624 64.2385 48.0701 64.4538 48.2854L65.997 49.8285C66.7626 50.5941 67.1453 51.5152 67.1453 52.5918C67.1453 53.6684 66.7626 54.5895 65.997 55.3551L61.547 59.805C61.3556 59.9964 61.1164 60.0921 60.8293 60.0921C60.5422 60.0921 60.291 59.9845 60.0757 59.7691ZM65.8175 65.511C65.6022 65.2957 65.4946 65.0445 65.4946 64.7574C65.4946 64.4703 65.6022 64.2191 65.8175 64.0038L67.3607 62.4606C68.1262 61.6951 69.0473 61.3123 70.1239 61.3123C71.2005 61.3123 72.1216 61.6951 72.8872 62.4606L74.4662 64.0397C74.6576 64.2311 74.7533 64.4703 74.7533 64.7574C74.7533 65.0445 74.6457 65.2957 74.4304 65.511C74.215 65.7263 73.9638 65.834 73.6767 65.834C73.3896 65.834 73.1384 65.7263 72.9231 65.511L71.38 63.9679C71.045 63.6329 70.6264 63.4655 70.1239 63.4655C69.6215 63.4655 69.2029 63.6329 68.8679 63.9679L67.2889 65.5469C67.0975 65.7383 66.8582 65.834 66.5712 65.834C66.2841 65.834 66.0329 65.7263 65.8175 65.511Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4419_239091",
    x: 0.146896,
    y: 0.507736,
    width: 122.909,
    height: 122.909,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.2273
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.211765 0 0 0 0 0.713726 0 0 0 0 0.588235 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4419_239091"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4419_239091",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHerocelebrate);
export default __webpack_public_path__ + "static/media/herocelebrate.23287b5fb0c9761ef62f8fd4ce13c7eb.svg";
export { ForwardRef as ReactComponent };